import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import { ValidText } from "../../contexts/Utils";
import {
  GetAllProductsInv,
  ProductInAllStores,
  AddInStock,
  AddOutStock,
} from "../../api";
import { Header, Button } from "../../components";
import { useStateContext } from "../../contexts/ContextProvider";
import "../../styles/AddProduct.css";
import { Container, Col, Row } from "react-bootstrap";
import Select from "react-select";
import { trackPromise } from "react-promise-tracker";

const TransferStock = () => {
  const navigate = useNavigate();
  const { currentColor, storeG, userID, userToken } = useStateContext();
  const [loadBtn, setLoadBtn] = useState(false);
  const [stor_notes, setstorNotes] = useState("");
  const [ValError, setValError] = useState([]);

  const [AllProducts, setAllProducts] = useState([]);
  const [Product, setProduct] = useState(null);
  const [Product_Options, setProduct_Options] = useState([]);

  const [to_stor, setto_stor] = useState(null);
  const [to_stor_Options, setto_stor_Options] = useState([]);
  const [GetStore_To, setGetStore_To] = useState([]);

  const [from_stor, setfrom_stor] = useState(null);
  const [from_stor_Options, setfrom_stor_Options] = useState([]);
  const [GetStore_From, setGetStore_From] = useState([]);

  const handleChangestorNote = (e) => {
    TimeoutUtility.resetTimeout();
    setstorNotes(e.target.value);
  };

  const handleChangestor_To = async (selectedOption) => {
    if (selectedOption === null) {
      setto_stor("");
    } else {
      if (selectedOption.label !== "") {
        const updatedErrors = [...ValError];
        updatedErrors[0] = "";
        setValError(updatedErrors);
      }
      if (selectedOption && selectedOption.value) {
        setto_stor(selectedOption);
      }
    }
  };

  const handleChangestor_From = async (selectedOption) => {
    if (selectedOption === null) {
      setfrom_stor("");
    } else {
      if (selectedOption.label !== "") {
        const updatedErrors = [...ValError];
        updatedErrors[1] = "";
        setValError(updatedErrors);
      }
      if (selectedOption && selectedOption.value) {
        setfrom_stor(selectedOption.stock);
      }
    }
  };

  const handleChangeProduct = async (selectedOption) => {
    if (selectedOption === null) {
      setProduct(null);
    } else {
      if (selectedOption.label !== "") {
        const updatedErrors = [...ValError];
        updatedErrors[4] = "";
        setValError(updatedErrors);
      }
      if (selectedOption && selectedOption.value) {
        setProduct(selectedOption);
      }
    }
  };

  const ValidText1 = (txt, ii) => {
    const updatedErrors = [...ValError];
    if (txt.trim().length === 0) {
      updatedErrors[ii] = "";
      setValError(updatedErrors);
      return false;
    }
    if (ValidText(txt)) {
      updatedErrors[ii] = "";
      setValError(updatedErrors);
      return true;
    }
    updatedErrors[ii] = "Invalid field!";
    setValError(updatedErrors);
    return false;
  };

  const handleBackClick = async (event) => {
    TimeoutUtility.resetTimeout();
    event.preventDefault();
    try {
      navigate("/Inventory");
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleSubmit = async (e) => {
    TimeoutUtility.resetTimeout();
    e.preventDefault();
    setLoadBtn(true);
    var resp = 0;
    try {
      const { amount_paid } = document.forms[0];

      setValError([]);
      const updatedErrors = [...ValError];

      if (Product === null || Product.value === null || Product.value === "") {
        updatedErrors[4] = "Please select Product to transfer!";
        setValError(updatedErrors);
        return;
      }
      updatedErrors[4] = "";

      if (
        from_stor === null ||
        from_stor.value === null ||
        from_stor.value === ""
      ) {
        updatedErrors[1] = "Please select transfered from store!";
        setValError(updatedErrors);
        return;
      }
      updatedErrors[1] = "";

      if (to_stor === null || to_stor.value === null || to_stor.value === "") {
        updatedErrors[0] = "Please select transfered in store!";
        setValError(updatedErrors);
        return;
      }
      if (to_stor.value === from_stor.value) {
        updatedErrors[0] = "Please select different store!";
        setValError(updatedErrors);
        return;
      }
      updatedErrors[0] = "";

      if (amount_paid.value === "") {
        updatedErrors[2] = "Please enter Qty transfered!";
        setValError(updatedErrors);
        return;
      }
      if (amount_paid.value < 1) {
        updatedErrors[2] = "Qty transfered must be greater than 0!";
        setValError(updatedErrors);
        return;
      }
      if (amount_paid.value > from_stor.qty) {
        updatedErrors[2] =
          "Qty must be less than the Inv Stk of transfered from store!";
        setValError(updatedErrors);
        return;
      }
      updatedErrors[2] = "";

      if (stor_notes) {
        if (ValidText1(stor_notes, 3) === false) {
          return;
        }
      }
      updatedErrors[3] = "";

      const response = await AddOutStock(
        from_stor.value,
        Product.value,
        amount_paid.value,
        704,
        stor_notes,
        userID,
        userToken
      );
      resp = response.status;
      if (resp === 200) {
        const response1 = await AddInStock(
          to_stor.value,
          Product.value,
          amount_paid.value,
          703,
          stor_notes,
          userID,
          userToken
        );
        resp = response1.status;
        if (resp === 200) {
          alert("Transfer Stock Added Successfully");
        } else {
          alert("Transfer Stock Failed to Add");
        }
      } else {
        alert("Transfer Stock Failed to Add");
      }
    } catch (err) {
    } finally {
      setLoadBtn(false);
      if (resp === 200) {
        navigate("/Inventory");
      }
    }
  };

  useEffect(() => {
    const fetchstor_ToOptions = async () => {
      if (GetStore_To.length > 0) {
        const fetchedProductOptions = GetStore_To.map((item) => ({
          label: item.store,
          value: item.store_id,
          stock: `${item.unit_instock} ${item.unit}`,
          qty: item.unit_instock,
        }));
        setto_stor_Options(fetchedProductOptions);
      }
    };
    fetchstor_ToOptions();
  }, [GetStore_To]);

  useEffect(() => {
    const fetchstor_ToOptions = async () => {
      if (GetStore_From.length > 0) {
        const fetchedProductOptions = GetStore_From.map((item) => ({
          label: item.store,
          value: item.store_id,
          stock: `${item.unit_instock} ${item.unit}`,
          qty: item.unit_instock,
        }));
        setfrom_stor_Options(fetchedProductOptions);
        if (storeG) {
          const storeid = fetchedProductOptions.find(
            (item) => item.value === storeG.store_id
          );
          if (storeid) {
            setfrom_stor(storeid);
          }
        }
      }
    };
    fetchstor_ToOptions();
  }, [GetStore_From]);

  useEffect(() => {
    TimeoutUtility.resetTimeout();
    async function fetchData() {
      if (userID && userToken && Product && Product.value !== 0) {
        await ProductInAllStores(Product.value, userID, userToken)
          .then((resp) => {
            setGetStore_From(resp.data || []);
            setGetStore_To(resp.data || []);
          })
          .catch((err) => {
            console.log(err.message);
          });
      }
    }
    fetchData();
  }, [userID, userToken, Product]);

  useEffect(() => {
    const fetchStoreOptions = async () => {
      if (AllProducts?.length > 0) {
        const fetchedStoreOptions = AllProducts.map((item) => ({
          label: `${item.code} ${item.name}`,
          value: item.product_id,
          stock: `${item.unit_instock} ${item.unit}`,
          qty: item.unit_instock,
        }));
        setProduct_Options(fetchedStoreOptions);
      }
    };
    fetchStoreOptions();
  }, [AllProducts]);

  useEffect(() => {
    TimeoutUtility.resetTimeout();
    async function fetchData() {
      if (userID && userToken) {
        trackPromise(
          Promise.all([GetAllProductsInv(userID, userToken)])
            .then(([result]) => {
              setAllProducts(result.data);
            })
            .catch((err) => {
              console.log(err.message);
            })
            .finally(() => {
              //setloading(false);
            })
        );
      }
    }
    fetchData();
  }, [userID, userToken]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 bg-white rounded-3xl">
      <Header title="TRANSFER STOCK" />
      <form>
        <Container
          className="g-0 justify-center"
          fluid="true"
          style={{ paddingLeft: "8%", paddingRight: "8%", paddingTop: "18px" }}
        >
          <Row
            xs={1}
            sm={1}
            className="justify-content-center"
            style={{ padding: "0" }}
          >
            <Col md={6} sm={6} className="container-col">
              <div className="col-lg-12">
                <div className="form-group">
                  <label className="label" htmlFor="ProductSelect">
                    Product:
                  </label>
                  <div className="flex mb-2">
                    <Select
                      className="myreact-select container-select"
                      value={Product}
                      onChange={handleChangeProduct}
                      options={Product_Options}
                      isSearchable
                      placeholder="Select Product To Transfer"
                      isClearable
                    />
                    <span className="label-imp-select">*</span>
                  </div>
                  {ValError[4] && (
                    <p className="label-error-select">{ValError[4]}</p>
                  )}
                </div>
              </div>
              <br />
              <div className="col-lg-12">
                <div className="form-group">
                  <label className="label" htmlFor="ProductSelect">
                    Transfered From:
                  </label>
                  <div className="flex mb-2">
                    <Select
                      className="myreact-select container-select"
                      value={from_stor}
                      onChange={handleChangestor_From}
                      options={from_stor_Options}
                      isSearchable
                      placeholder="Select Transfered From Store"
                      isClearable
                    />
                    <span className="label-imp-select">*</span>
                  </div>
                  {ValError[1] && (
                    <p className="label-error-select">{ValError[1]}</p>
                  )}
                </div>
              </div>
              <br />
              <div className="col-lg-12">
                <div className="form-group">
                  <label className="label" htmlFor="ProductSelect">
                    Transfered In:
                  </label>
                  <div className="flex mb-2">
                    <Select
                      className="myreact-select container-select"
                      value={to_stor}
                      onChange={handleChangestor_To}
                      options={to_stor_Options}
                      isSearchable
                      placeholder="Select Transfered In Store"
                      isClearable
                    />
                    <span className="label-imp-select">*</span>
                  </div>
                  {ValError[0] && (
                    <p className="label-error-select">{ValError[0]}</p>
                  )}
                </div>
              </div>
              <br />
              <div className="col-lg-12">
                <div className="form-group">
                  <label className="label">Quantity Transfered:</label>
                  <input
                    type="number"
                    step="1.00"
                    min="0"
                    defaultValue={0.0}
                    name="amount_paid"
                    placeholder="Enter Quantity Transfered"
                    className="input"
                  />
                  <span className="label-imp">*</span>
                  {ValError[2] && <p className="label-error">{ValError[2]}</p>}
                </div>
              </div>
              <br />
              <div className="col-lg-12">
                <div className="form-group">
                  <label className="label">Note: </label>
                  <textarea
                    placeholder="Note"
                    id="noteTextarea"
                    value={stor_notes}
                    onChange={handleChangestorNote}
                    className="textarea"
                    onBlur={(e) => ValidText1(e.target.value, 3)}
                  />
                  {ValError[3] && (
                    <p className="label-error-dt">{ValError[3]}</p>
                  )}
                </div>
              </div>
              <br />
              <br />
            </Col>
            <Col md={2} sm={2} className="container-col">
              <div className="col-lg-12">
                <div className="form-group mt-8">
                  <label className="label">Total Stk: {Product?.stock}</label>
                </div>
              </div>
              <br />
              <div className="col-lg-12">
                <div className="form-group mt-8">
                  <label className="label">Inv Stk: {from_stor?.stock}</label>
                </div>
              </div>
              <br />
              <div className="col-lg-12">
                <div className="form-group mt-8">
                  <label className="label">Inv Stk: {to_stor?.stock}</label>
                </div>
              </div>
              <br />
            </Col>
          </Row>
        </Container>
      </form>
      <Row md={"auto"} className="justify-content-center">
        <Button
          margin="10px"
          padding="20px"
          color="white"
          className="custom-button ml-2"
          bgColor={currentColor}
          text="Add"
          borderRadius="10px"
          onClick={handleSubmit}
          disabled={loadBtn}
        />
        <Button
          margin="10px"
          padding="20px"
          color="white"
          className="custom-button ml-2"
          bgColor={currentColor}
          text="Back"
          borderRadius="10px"
          onClick={handleBackClick}
        />
      </Row>
    </div>
  );
};

export default TransferStock;
